import React from "react";
import { useRoom } from "../hooks/useRoom";
import { __RoomContext } from "./context";
import { LOCAL_CHANNEL_NAME } from "../constants";
export const RoomProvider = ({ name = LOCAL_CHANNEL_NAME, children, }) => {
    const currentRoom = useRoom(name);
    return (React.createElement(__RoomContext.Provider, { value: currentRoom }, children));
};
